export default __webpack_public_path__ + "static/pusher-logo-0576fd4af5c38706f96f632235f3124a.svg";